import styled, { css } from 'styled-components'
import { ScrollBarStyles } from 'src/components/Core/Styles/general-utilities'
import Flex from '../../Layout/Flex/Flex'
import { ModalContainerProps } from './types'

export const ModalOverlay = styled('div')`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 20;
  background-color: ${props => props.theme.colors.main.dark};
  opacity: 0.8;
`

export const ModalContainer = styled('div') <ModalContainerProps>`
  position: fixed;
  z-index: 30;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: ${props => props.theme.colors.main.background};
  box-shadow: 0px 8px 10px ${props => props.theme.colors.shades.neutral[7]};
  border-radius: 4px;
  width: 637px;
  max-height: 90vh;
  overflow-y: auto;

  ${props => props.large && css`
    width: 75%;
    max-width: 1250px;
  `}

  ${props => props.extraLarge && css`
    width: 90%;
    max-width: 1420px;
  `}

  ${props => props.xlLarge && css`
    width: 95%;
    max-width: 1420px;
  `}

  ${props => props.width && css`
    @media (max-width: 1550px) {
      width: ${props.width};
       max-width: 1550px;
    }
  `}

  @media (max-width: 700px) {
    width: 90%;
  }

  ${ScrollBarStyles}
`

export const ModalHeader = styled('header') <{ bgColor?: string; }>`
  background-color: ${props => props.theme.colors.main[`${props.bgColor || 'dark'}`]};
  border-radius: 4px 4px 0px 0px;
  padding: 32px;
`

export const ModalBody = styled('div')`
  padding: 32px;
`

export const ModalFooter = styled(Flex).attrs({
  as: 'footer',
  justifyContent: 'flex-end',
}) <{ fixedWidthButton?: string; }>`
  margin: 0px 32px;
  padding: 16px 0px;
  border-top: 1px solid ${props => props.theme.colors.shades.neutral[1]};

  ${props => props.fixedWidthButton && css`
    button {
      width: ${props.fixedWidthButton};
    }
  `}


  button:nth-child(2) {
    margin-left: 16px;
  }
`
